import { CALL_API } from "../../middlewares/api";

export const DEPOSIT_LIST_GET_REQUEST = "DEPOSIT_LIST_GET_REQUEST";
export const DEPOSIT_LIST_GET_SUCCESS = "DEPOSIT_LIST_GET_SUCCESS";
export const DEPOSIT_LIST_GET_ERROR = "DEPOSIT_LIST_GET_ERROR";

export function get_deposits(
  types = [
    DEPOSIT_LIST_GET_REQUEST,
    DEPOSIT_LIST_GET_SUCCESS,
    DEPOSIT_LIST_GET_ERROR,
  ],
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/deposits",
      authenticatedRequest: true,
      types,
    },
  };
}

export function get_deposits_by_account(accountId) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/fundorders/depositsbyaccount?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        DEPOSIT_LIST_GET_REQUEST,
        DEPOSIT_LIST_GET_SUCCESS,
        DEPOSIT_LIST_GET_ERROR,
      ],
    },
  };
}

export const DEPOSITS_LIST_CHANGE_PAGE = "DEPOSITS_LIST_CHANGE_PAGE";

export function change_deposits_list_page(page) {
  return {
    type: DEPOSITS_LIST_CHANGE_PAGE,
    page,
  };
}

export const DEPOSITS_LIST_CHANGE_FILTER = "DEPOSITS_LIST_CHANGE_FILTER";

export function change_deposits_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: DEPOSITS_LIST_CHANGE_FILTER,
    filter,
  };
}

export const WITHDRAW_LIST_GET_REQUEST = "WITHDRAW_LIST_GET_REQUEST";
export const WITHDRAW_LIST_GET_SUCCESS = "WITHDRAW_LIST_GET_SUCCESS";
export const WITHDRAW_LIST_GET_ERROR = "WITHDRAW_LIST_GET_ERROR";

export function get_withdraws() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/withdrawals",
      authenticatedRequest: true,
      types: [
        WITHDRAW_LIST_GET_REQUEST,
        WITHDRAW_LIST_GET_SUCCESS,
        WITHDRAW_LIST_GET_ERROR,
      ],
    },
  };
}

export function get_withdraws_by_account(accountId) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/fundorders/withdrawalsbyaccount?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        WITHDRAW_LIST_GET_REQUEST,
        WITHDRAW_LIST_GET_SUCCESS,
        WITHDRAW_LIST_GET_ERROR,
      ],
    },
  };
}

export const WITHDRAWAL_LIST_CHANGE_PAGE = "WITHDRAWAL_LIST_CHANGE_PAGE";

export function change_withdrawal_list_page(page) {
  return {
    type: WITHDRAWAL_LIST_CHANGE_PAGE,
    page,
  };
}

export const WITHDRAWAL_LIST_CHANGE_FILTER = "WITHDRAWAL_LIST_CHANGE_FILTER";

export function change_withdrawal_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: WITHDRAWAL_LIST_CHANGE_FILTER,
    filter,
  };
}

export const SEND_BACK_LIST_GET_REQUEST = "SEND_BACK_LIST_GET_REQUEST";
export const SEND_BACK_LIST_GET_SUCCESS = "SEND_BACK_LIST_GET_SUCCESS";
export const SEND_BACK_LIST_GET_ERROR = "SEND_BACK_LIST_GET_ERROR";

export function get_send_backs() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/get-unconfirmed-send-back-orders",
      authenticatedRequest: true,
      types: [
        SEND_BACK_LIST_GET_REQUEST,
        SEND_BACK_LIST_GET_SUCCESS,
        SEND_BACK_LIST_GET_ERROR,
      ],
    },
  };
}

export const CONFIRM_SEND_BACK_ORDER_REQUEST =
  "CONFIRM_SEND_BACK_ORDER_REQUEST";
export const CONFIRM_SEND_BACK_ORDER_SUCCESS =
  "CONFIRM_SEND_BACK_ORDER_SUCCESS";
export const CONFIRM_SEND_BACK_ORDER_ERROR = "CONFIRM_SEND_BACK_ORDER_ERROR";

export function confirm_send_back_order(Id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/confirm-special-account-transaction-order",
      authenticatedRequest: true,
      data: { Id },
      method: "POST",
      types: [
        CONFIRM_SEND_BACK_ORDER_REQUEST,
        {
          method: refetchSendBackOrders.bind(
            this,
            CONFIRM_SEND_BACK_ORDER_SUCCESS,
          ),
        },
        CONFIRM_SEND_BACK_ORDER_ERROR,
      ],
    },
  };
}

function refetchSendBackOrders(type, response) {
  return (dispatch) => {
    dispatch({
      type,
      response,
    });
    dispatch(get_send_backs());
  };
}

export const APPROVE_DEPOSIT_ORDER_REQUEST = "APPROVE_DEPOSIT_ORDER_REQUEST";
export const APPROVE_DEPOSIT_ORDER_SUCCESS = "APPROVE_DEPOSIT_ORDER_SUCCESS";
export const APPROVE_DEPOSIT_ORDER_ERROR = "APPROVE_DEPOSIT_ORDER_ERROR";

export function approve_deposit_order(
  orderId,
  accountId,
  depotId,
  paymentId,
  amount,
  date,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/depositbg/transfer",
      method: "POST",
      data: {
        OrderId: orderId,
        AccountId: accountId,
        DepotId: depotId,
        PaymentId: paymentId,
        Amount: amount,
        BankReceiveDate: date,
      },
      authenticatedRequest: true,
      types: [
        APPROVE_DEPOSIT_ORDER_REQUEST,
        APPROVE_DEPOSIT_ORDER_SUCCESS,
        APPROVE_DEPOSIT_ORDER_ERROR,
      ],
    },
  };
}

export const REJECT_ORDER_REQUEST = "REJECT_ORDER_REQUEST";
export const REJECT_ORDER_SUCCESS = "REJECT_ORDER_SUCCESS";
export const REJECT_ORDER_ERROR = "REJECT_ORDER_ERROR";

export function reject_order(orderId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/rejectdeposit",
      method: "POST",
      data: { OrderId: orderId },
      authenticatedRequest: true,
      types: [REJECT_ORDER_REQUEST, REJECT_ORDER_SUCCESS, REJECT_ORDER_ERROR],
    },
  };
}

export const APPROVE_WITHDRAWAL_ORDER_REQUEST =
  "APPROVE_WITHDRAWAL_ORDER_REQUEST";
export const APPROVE_WITHDRAWAL_ORDER_SUCCESS =
  "APPROVE_WITHDRAWAL_ORDER_SUCCESS";
export const APPROVE_WITHDRAWAL_ORDER_ERROR = "APPROVE_WITHDRAWAL_ORDER_ERROR";

export function approve_withdrawal_order(
  orderId,
  accountId,
  depotId,
  amount,
  date,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/confirmwithdrawal",
      method: "POST",
      data: {
        OrderId: orderId,
        AccountId: accountId,
        DepotId: depotId,
        Amount: amount,
        BankReceiveDate: date,
      },
      authenticatedRequest: true,
      types: [
        APPROVE_WITHDRAWAL_ORDER_REQUEST,
        APPROVE_WITHDRAWAL_ORDER_SUCCESS,
        APPROVE_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}

export function approve_withdrawal_orders(list) {
  return (dispatch) => {
    if (list.length === 0) return;
    const item = list.pop();
    const dataSent = {
      OrderId: item.Id,
      AccountId: item.AccountId,
      DepotId: item.DepotId,
      Amount: item.Amount,
      BankReceiveDate: item.OrderDate,
    };
    dispatch({
      [CALL_API]: {
        endpoint: "/api/admin/fundorders/confirmwithdrawal",
        method: "POST",
        data: dataSent,
        authenticatedRequest: true,
        types: [
          APPROVE_WITHDRAWAL_ORDER_REQUEST,
          {
            method: approve_withdrawal_orders_success.bind(
              this,
              list,
              dataSent,
            ),
          },
          {
            method: approve_withdrawal_orders_error.bind(this, list, dataSent),
          },
        ],
      },
    });
  };
}

function approve_withdrawal_orders_success(list, dataSent, response) {
  return (dispatch) => {
    dispatch({
      type: APPROVE_WITHDRAWAL_ORDER_SUCCESS,
      dataSent,
      response,
    });
    dispatch(approve_withdrawal_orders(list));
  };
}

function approve_withdrawal_orders_error(list, dataSent, response) {
  return (dispatch) => {
    dispatch({
      type: APPROVE_WITHDRAWAL_ORDER_ERROR,
      dataSent,
      response,
    });
    dispatch(approve_withdrawal_orders(list));
  };
}

export const CANCEL_WITHDRAWAL_ORDER_REQUEST =
  "CANCEL_WITHDRAWAL_ORDER_REQUEST";
export const CANCEL_WITHDRAWAL_ORDER_SUCCESS =
  "CANCEL_WITHDRAWAL_ORDER_SUCCESS";
export const CANCEL_WITHDRAWAL_ORDER_ERROR = "CANCEL_WITHDRAWAL_ORDER_ERROR";

export function cancel_withdrawal_order(orderId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/cancelwithdrawal",
      method: "POST",
      data: { OrderId: orderId },
      authenticatedRequest: true,
      types: [
        CANCEL_WITHDRAWAL_ORDER_REQUEST,
        CANCEL_WITHDRAWAL_ORDER_SUCCESS,
        CANCEL_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}

export const PLACE_WITHDRAWAL_ORDER_REQUEST = "PLACE_WITHDRAWAL_ORDER_REQUEST";
export const PLACE_WITHDRAWAL_ORDER_SUCCESS = "PLACE_WITHDRAWAL_ORDER_SUCCESS";
export const PLACE_WITHDRAWAL_ORDER_ERROR = "PLACE_WITHDRAWAL_ORDER_ERROR";

export function placeWithdrawal(
  amount,
  bankAccountId,
  depotId,
  isSalesPerformanceExcluded,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/createwithdrawal",
      method: "POST",
      data: {
        Amount: amount,
        BankAccountId: bankAccountId,
        DepotId: depotId,
        IsSalesPerformanceExcluded: isSalesPerformanceExcluded,
      },
      authenticatedRequest: true,
      types: [
        PLACE_WITHDRAWAL_ORDER_REQUEST,
        PLACE_WITHDRAWAL_ORDER_SUCCESS,
        PLACE_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}
export const PLACE_FORCE_WITHDRAWAL_ORDER_REQUEST =
  "PLACE_FORCE_WITHDRAWAL_ORDER_REQUEST";
export const PLACE_FORCE_WITHDRAWAL_ORDER_SUCCESS =
  "PLACE_FORCE_WITHDRAWAL_ORDER_SUCCESS";
export const PLACE_FORCE_WITHDRAWAL_ORDER_ERROR =
  "PLACE_FORCE_WITHDRAWAL_ORDER_ERROR";

export function placeForceWithdrawal(
  amount,
  bankAccountId,
  depotId,
  isSalesPerformanceExcluded,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/force-createwithdrawal",
      method: "POST",
      data: {
        Amount: amount,
        BankAccountId: bankAccountId,
        DepotId: depotId,
        IsSalesPerformanceExcluded: isSalesPerformanceExcluded,
      },
      authenticatedRequest: true,
      types: [
        PLACE_FORCE_WITHDRAWAL_ORDER_REQUEST,
        PLACE_FORCE_WITHDRAWAL_ORDER_SUCCESS,
        PLACE_FORCE_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}

export const PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_REQUEST =
  "PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_REQUEST";
export const PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_SUCCESS =
  "PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_SUCCESS";
export const PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_ERROR =
  "PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_ERROR";

export function placeMegaForceWithdrawal(
  amount,
  bankAccountId,
  depotId,
  isSalesPerformanceExcluded,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/mega-force-createwithdrawal",
      method: "POST",
      data: {
        Amount: amount,
        BankAccountId: bankAccountId,
        DepotId: depotId,
        IsSalesPerformanceExcluded: isSalesPerformanceExcluded,
      },
      authenticatedRequest: true,
      types: [
        PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_REQUEST,
        PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_SUCCESS,
        PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}

export const SWAP_DEPOSIT_DATA = "SWAP_DEPOSIT_DATA";

export function swap_data() {
  return {
    type: SWAP_DEPOSIT_DATA,
  };
}

/* BONUSES */

export const REGISTER_BONUS_REQUEST = "REGISTER_BONUS_REQUEST";
export const REGISTER_BONUS_SUCCESS = "REGISTER_BONUS_SUCCESS";
export const REGISTER_BONUS_ERROR = "REGISTER_BONUS_ERROR";

export function register_bonus(bonus, depotId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/bonus-order/register",
      method: "POST",
      data: { DepotId: depotId, Amount: bonus },
      authenticatedRequest: true,
      types: [
        REGISTER_BONUS_REQUEST,
        REGISTER_BONUS_SUCCESS,
        REGISTER_BONUS_ERROR,
      ],
    },
  };
}

export const CONFIRM_BONUS_REQUEST = "CONFIRM_BONUS_REQUEST";
export const CONFIRM_BONUS_SUCCESS = "CONFIRM_BONUS_SUCCESS";
export const CONFIRM_BONUS_ERROR = "CONFIRM_BONUS_ERROR";

export function confirm_bonus(bonusId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/bonus-order/confirm",
      method: "POST",
      data: { OrderId: bonusId },
      authenticatedRequest: true,
      types: [
        CONFIRM_BONUS_REQUEST,
        CONFIRM_BONUS_SUCCESS,
        CONFIRM_BONUS_ERROR,
      ],
    },
  };
}

export const FETCH_CREATED_BONUS_REQUEST = "FETCH_CREATED_BONUS_REQUEST";
export const FETCH_CREATED_BONUS_SUCCESS = "FETCH_CREATED_BONUS_SUCCESS";
export const FETCH_CREATED_BONUS_ERROR = "FETCH_CREATED_BONUS_ERROR";

export function fetch_created_bonuses() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/bonus-orders",
      method: "GET",
      authenticatedRequest: true,
      types: [
        FETCH_CREATED_BONUS_REQUEST,
        FETCH_CREATED_BONUS_SUCCESS,
        FETCH_CREATED_BONUS_ERROR,
      ],
    },
  };
}

export const CANCEL_BONUS_REQUEST = "CANCEL_BONUS_REQUEST";
export const CANCEL_BONUS_SUCCESS = "CANCEL_BONUS_SUCCESS";
export const CANCEL_BONUS_ERROR = "CANCEL_BONUS_ERROR";

export function cancel_bonus_order(bonusId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/bonus-order/cancel",
      method: "POST",
      data: { OrderId: bonusId },
      authenticatedRequest: true,
      types: [CANCEL_BONUS_REQUEST, CANCEL_BONUS_SUCCESS, CANCEL_BONUS_ERROR],
    },
  };
}
